export default function () {
    return {
        compareMaxItems: 4,
        compareItems: [],
        init() {
            this.getCompareProducts();
            this.compareProductsWatcher();
        },
        getCompareProducts() {
            const compare =
                this.$store.mageCacheStorage.data['compare-products'];

            if (compare && compare?.items?.length) {
                this.compareItems = compare.items;

                if (this.compareItems.length < this.compareMaxItems) {
                    Array(this.compareMaxItems - this.compareItems.length)
                        .fill(0)
                        .forEach(() => {
                            this.compareItems.push({
                                id: '',
                                product_url: '',
                                name: '',
                                remove_url: ''
                            });
                        });
                }
            }
        },
        removeProductFromCompare(data) {
            window.dispatchEvent(
                new CustomEvent('removeCompareProduct', {
                    detail: {
                        data
                    }
                })
            );
        },
        compareProductCount() {
            const compare =
                this.$store.mageCacheStorage.data['compare-products'];

            if (compare) {
                return compare.count;
            }

            return 0;
        },
        compareBtnText(text) {
            return text
                .replace('$1', this.compareProductCount())
                .replace('$2', this.compareMaxItems);
        },
        compareProductsWatcher() {
            this.$watch(
                '$store.mageCacheStorage.data["compare-products"]',
                (newValue, oldValue) => {
                    if (newValue !== oldValue) {
                        this.getCompareProducts();
                    }
                }
            );
        },
        compareIsActive: JSON.parse(localStorage.getItem('compareIsActive'))
            ? true
            : false,
        toggleVisibility() {
            localStorage.setItem(
                'compareIsActive',
                JSON.stringify(this.compareIsActive)
            );
        }
    };
}
